import { UIStateProps, uiState } from '../../atoms/uiAtom';

import { Navigate } from 'react-router-dom';
import { routes } from '../../routes';
import { useEffect } from 'react';
import { useGetTermsAndConditions } from '../../hooks/termsAndConditions';
import { useSetRecoilState } from 'recoil';

interface HasNewTermsAndConditionsProps {
  children: JSX.Element;
}
export default function HasNewTermsAndConditions({ children }: HasNewTermsAndConditionsProps) {
  const { isFetching, isError, data: termsAndConditions } = useGetTermsAndConditions();

  const setUiState = useSetRecoilState<UIStateProps>(uiState);

  useEffect(() => {
    setUiState((prev) => ({ ...prev, hasError: isError, isFetching }));
  }, [setUiState, isError, isFetching]);

  return termsAndConditions ? (
    <Navigate
      to={routes.TERMS_AND_CONDITIONS.path}
      state={{
        termsAndConditions: encodeURIComponent(termsAndConditions?.data!),
        hasFooter: true,
      }}
    />
  ) : (
    children
  );
}
